import constants from "../constants";
import util, { getEmptyPrice } from "../util";

/*
moRendererConfig:

iconAlign: 'icon-left' || 'icon-right',
iconPosition: 'name' || 'description' || 'price',
showTags: bool,
menuTagLayout: 'below' || 'above',
hidePrices: bool,
inlineExtras: bool,
showModifiers: bool,
modifierLayout: 'in-line' || 'stacked'

*/

const prices = (params, cfg) => {
  cfg = cfg || {};
  const tag = cfg.tag || 'span';
  const wrapSizeSeparately = cfg.wrapSizeSeparately || false;
  const hideSize = cfg.hideSize || false;
  const addClassToLastValidElement = cfg.addClassToLastValidElement || false;

  let content = `<${tag} class="price ${cfg.clone ? 'cloned-price' : ''}" style="${cfg.style || ''} ${cfg.clone ? 'visibility: hidden; opacity: 0;' : ''}">`;
  if (params) {
    params = params.sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
    for (let i = 0; i < params.length; i++) {
      const price = params[i];
      if (price !== null && price !== '') {
        const priceAndSize = getFromJson(price);
        const isEmpty = isEmptySizeAndPrice(price);
        let isLastValid = params.length - 1 === i;
        let forceAddLastClass = false;
        if (addClassToLastValidElement) {
          if (i + 1 < params.length) {
            const nextPrice = params[i + 1];
            forceAddLastClass = isEmptySizeAndPrice(nextPrice);
          }
        }
        content += `<span 
          class="${cfg.clone ? '' : `price-entry${isEmpty ? ' empty' : ''} ${isLastValid || forceAddLastClass ? 'last' : ''}`}" 
          style="${cfg.priceStyle || ''} ${cfg.hidePrices ? 'display: none;' : ''}" 
          data-pv="${priceAndSize.price || ''}" 
          data-ps="${priceAndSize.size || ''}">
            ${getSizeAndPrice(price, wrapSizeSeparately, hideSize)}
          </span>`
      }
    }
  }
  content += `</${tag}>`;
  return content;
};

const icons = (params, cfg) => {
  cfg = cfg || {};
  const tag = cfg.tag || 'span';
  let content = '';
  if (typeof params !== 'undefined' && params.length > 0) {
    content = `<${tag} class="icon" style="${cfg.style || ''}">`;
    params.forEach((icon, idx) => {
      if (icon !== null && icon.iconKey !== '') {
        if (icon.type === 'svg') {
          content += (!icon.fill ?
            `<svg class="icon-entry" icon-type="${icon.type}" icon-key="${icon.iconKey}" icon-source="${icon.source ? icon.source : ''}" icon-fill style="${'fill:;'}" role="img" aria-label="${icon.altText}"><use xlink:href="${!constants.isLocalhost ? window.location.href.replace('http:', 'https:').replace(window.location.pathname, '').replace(window.location.search, '') : ''}${constants.appPrefix}/svg/icon-library/menu-icons.svg#${icon.iconKey}"></use></svg>` :
            `<svg class="icon-entry" icon-type="${icon.type}" icon-key="${icon.iconKey}" icon-source="${icon.source ? icon.source : ''}" icon-fill="${icon.fill}" style="${'fill: ' + icon.fill + ';'}" role="img" aria-label="${icon.altText}"><use xlink:href="${!constants.isLocalhost ? window.location.href.replace('http:', 'https:').replace(window.location.pathname, '').replace(window.location.search, '') : ''}${constants.appPrefix}/svg/icon-library/menu-icons.svg#${icon.iconKey}"></use></svg>`);
        } else if (icon.type === 'letter') {
          content += (!icon.fill ?
            `<span class="icon-entry" icon-type="${icon.type}" icon-key="${icon.iconKey}" icon-source="${icon.source ? icon.source : ''}" icon-fill style="color:;">${icon.iconKey}</span>` :
            `<span class="icon-entry" icon-type="${icon.type}" icon-key="${icon.iconKey}" icon-source="${icon.source ? icon.source : ''}" icon-fill="${icon.fill}" style="color: ${icon.fill};">${icon.iconKey}</span>`);
        } else {
          if (icon.iconKey.includes("icon-uploads")) {
            content += `<img class="icon-entry" icon-type="${icon.type}" icon-key="${icon.iconKey}" icon-source="${icon.source ? icon.source : ''}" src="${util.getUploadedIconPath(icon)}" alt="${icon.altText ? icon.altText : ''}" />`;
          } else {
            content += `<img class="icon-entry" icon-type="${icon.type}" icon-key="${icon.iconKey}" icon-source="${icon.source ? icon.source : ''}" src="${constants.SECURE_S3_OO_PATH + icon.iconKey}" alt="${icon.altText ? icon.altText : ''}" />`;
          }
        }

        if (idx < params.length - 1) {
          content += `<span>&nbsp;</span>`;
        }
      }
    });
    content += `</${tag}>`;
  }
  return content;
};

const processItemNameAndIcons = (item, cfg, iconAlign, iconPosition) => {
  cfg = cfg || {};
  const tag = cfg.tag || 'span';
  cfg.style = cfg.style || '';
  cfg.style = 'overflow-wrap: break-word;' + cfg.style;

  let content = '';
  if (typeof item.icons !== 'undefined' && item.icons.length > 0 && iconPosition === 'name') {
    if (iconAlign === 'icon-left') {
      content = `<${tag} style="${cfg.style || ''}">${icons(item.icons, { style: 'padding-right: .5em;' })}<span class="name">${str(item.name, isBlankItem(item))}</span></${tag}>`;
    } else {
      content = `<${tag} style="${cfg.style || ''}"><span class="name">${str(item.name, isBlankItem(item))}</span>${icons(item.icons, { style: 'padding-left: .5em;' })}</${tag}>`;
    }
  } else {
    content = `<${tag} class="name" style="${cfg.style || ''}">${str(item.name, isBlankItem(item))}</${tag}>`;
  }
  return content;
};

const wrap = (content, data, $item) => {
  data = data || {};
  return `<div 
        class="item ${$item && $item.hasClass('highlighted') ? 'highlighted' : ''}" 
        ${data.mock ? ' data-mock="true"' : ''} 
        ${data.source ? ` data-source="${data.source}"` : ''}
        ${data.id ? ` data-id="${data.id}"` : ''}
        ${$item && $item.attr('data-highlight-id') ? ` data-highlight-id="${$item.attr('data-highlight-id')}"` : ''}>
          ${content}
        </div>`;
};

const hiddenBinItem = (item) => {
  return `<div style="display: none;" class="bin-entry"><div class="bin-header">${item.binHeader ? item.binHeader : ''}</div><div class="bin">${item.bin ? item.bin : ''}</div></div>`;
}

const getModifiers = (modifiers, cfg, textAlign='left') => {
  if (!modifiers) modifiers = [];
  const parsedMods = modifiers.map(m => typeof m === 'string' ? JSON.parse(m) : m);
  let line = '';
  // if modifiers
  line += `<div class="modifiers" style="${!cfg.showModifiers ? 'display: none;' : ''} text-align: ${textAlign};">`;
  parsedMods.forEach(m => {
    line += `<div class="modifier">`;
    line += `<div class="modifier-name">${m.name}</div>`;
    if (cfg.modifierLayout === 'in-line') line += `<div class="modifier-entries" style="display: flex; flex-wrap: wrap; align-items: center; justify-content: ${textAlign === 'center' ? 'center' : textAlign === 'right' ? 'flex-end' : 'flex-start'};">`;
    if (m.entries) {
      m.entries.forEach((e, idx) => {
        if (e.name || e.price) {
          line += `<div class="modifier-entry" style="position: relative; ${cfg.modifierLayout === 'stacked' || idx >= (m.entries.length - 1 ) ? '' : 'margin-right: 0.5em;'}">`;
          line += `<span class="modifier-entry-name">${e.name}</span>`;
          line += `<span style="padding-left: 0.25em; ${cfg.hidePrices ? 'display: none;' : ''}" class="modifier-entry-price" data-pv="${e.price}">${e.displayPrice ? e.displayPrice : e.price}</span>`;
          line += `</div>`;
        }
      })
    }
    if (cfg.modifierLayout === 'in-line') line += `</div>`;
    line += `</div>`;
  })
  line += `</div>`;
  
  return line;
}

const inlineExtrasLeftPadding = '0';

const Renderer = (() => {
  const renderer = {};
  renderer['price-name-left'] = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = ``;
      line += hiddenBinItem(item);

      if (moRendererConfig.iconPosition === 'name') {
        if (moRendererConfig.iconAlign === 'icon-left') {
          line += `
              <div>
                  ${icons(item.icons, { style: 'padding-right: .5em;' })}
                  <span class="name">${str(item.name, isBlankItem(item))}</span>
                  ${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}
              </div>`;
        } else {
          line += `<div>
              <span class="name">${str(item.name, isBlankItem(item))}</span>
              ${icons(item.icons, { style: 'padding-left: .5em;' })}
              ${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}
          </div>`;
        }
      } else if (moRendererConfig.iconPosition === 'price') {
        line += `<div>
            <span class="name">${str(item.name, isBlankItem(item))}</span>
            ${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}
            ${icons(item.icons)}
        </div>`;
      } else {
        line += `<div>
            <span class="name">${str(item.name, isBlankItem(item))}</span>
            ${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}
        </div>`;
      }

      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `<div class="description-block" style="line-height: 1em;">`;
      }
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<div class="description" style="${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</div>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += `<div class="extras" style="${moRendererConfig.inlineExtras ? `display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};` : ''}">${str(item.extras)}</div>`;
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `</div>`;
      }
      line += getModifiers(item.modifiers, moRendererConfig);
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['price-name-float-right'] = (items, $clone, moRendererConfig) => {
    const prevLineHeight = $clone?.find('.item div.name-price-wrapper').css('line-height') || 'inherit';
    return items.filter(it => it).map((item) => {
      let line = ``;
      line += hiddenBinItem(item);
      if (moRendererConfig.iconPosition === 'name') {
        if (moRendererConfig.iconAlign === 'icon-left') {
          line += `
              <div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
                  ${icons(item.icons, { style: 'padding-right: .5em;' })}
                  <span class="name" style="margin: 0 !important;">${str(item.name, isBlankItem(item))}</span>
                  ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0 0 0 auto; line-height: ${prevLineHeight};`, addClassToLastValidElement: true, hidePrices: moRendererConfig.hidePrices })}
              </div>`;
        } else {
          line += `<div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
              <span class="name" style="margin: 0 !important;">${str(item.name, isBlankItem(item))}</span>
              ${icons(item.icons, { style: 'padding-left: .5em;' })}
              ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0 0 0 auto; line-height: ${prevLineHeight};`, addClassToLastValidElement: true, hidePrices: moRendererConfig.hidePrices })}
          </div>`;
        }
      } else if (moRendererConfig.iconPosition === 'price') {
        line += `<div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
          <span class="name" style="margin: 0 !important;">${str(item.name, isBlankItem(item))}</span>
          ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0 0 0 auto; line-height: ${prevLineHeight};`, addClassToLastValidElement: true, hidePrices: moRendererConfig.hidePrices })}
          ${icons(item.icons, { style: 'padding-left: .5em; line-height: 1em;' })}
        </div>`;
      } else {
        line += `
            <div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
                <span class="name" style="margin: 0 !important;">${str(item.name, isBlankItem(item))}</span>
                ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0 0 0 auto; line-height: ${prevLineHeight};`, addClassToLastValidElement: true, hidePrices: moRendererConfig.hidePrices })}
            </div>`;
      }
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `<div class="description-block" style="line-height: 1em;">`;
      }
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<div class="description" style="${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</div>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += `<div class="extras" style="${moRendererConfig.inlineExtras ? `display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};` : ''}">${str(item.extras)}</div>`;
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `</div>`;
      }
      line += getModifiers(item.modifiers, moRendererConfig);
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['price-name-float-right-with-dot-leaders'] = (items, $clone, moRendererConfig) => {
    const prevLineHeight = $clone?.find('.item div.name-price-wrapper').css('line-height') || 'inherit';
    return items.filter(it => it).map((item) => {
      let line = ``;
      line += hiddenBinItem(item);
      if (moRendererConfig.iconPosition === 'name') {
        if (moRendererConfig.iconAlign === 'icon-left') {
          line += `
              <div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
                  ${icons(item.icons, { style: 'padding-right: .5em;' })}
                  <span class="name" style="flex: 1;">${str(item.name, isBlankItem(item))}</span>
                  ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0; line-height: ${prevLineHeight};`, hidePrices: moRendererConfig.hidePrices })}
              </div>`;
        } else {
          line += `<div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
              <span class="name" style="flex: 1; margin: 0 !important;">${str(item.name, isBlankItem(item))}</span>
              ${icons(item.icons, { style: 'padding-left: .5em;' })}
              ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0; line-height: ${prevLineHeight};`, hidePrices: moRendererConfig.hidePrices })}
          </div>`;
        }
      } else if (moRendererConfig.iconPosition === 'price') {
        line += `<div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
            <span class="name" style="flex: 1; margin: 0 !important;">${str(item.name, isBlankItem(item))}</span>
            ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0; line-height: ${prevLineHeight};`, hidePrices: moRendererConfig.hidePrices })}
            ${icons(item.icons, { style: 'padding-left: .5em;' })}
        </div>`;
      } else {
        line += `<div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
              <span class="name" style="flex: 1; margin: 0 !important;">${str(item.name, isBlankItem(item))}</span>
              ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0; line-height: ${prevLineHeight};`, hidePrices: moRendererConfig.hidePrices })}
          </div>`;
      }
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `<div class="description-block" style="line-height: 1em;">`;
      }
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<div class="description" style="${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</div>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += `<div class="extras" style="${moRendererConfig.inlineExtras ? `display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};` : ''}">${str(item.extras)}</div>`;
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `</div>`;
      }
      line += getModifiers(item.modifiers, moRendererConfig);
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['price-name-center'] = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = ``;
      line += hiddenBinItem(item);
      if (moRendererConfig.iconPosition === 'name') {
        if (moRendererConfig.iconAlign === 'icon-left') {
          line += `<div style="text-align: center;">
              ${icons(item.icons, { style: 'padding-right: .5em;' })}
              <span class="name">${str(item.name, isBlankItem(item))}</span>
              ${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}
          </div>`;
        } else {
          line += `<div style="text-align: center;">
              <span class="name">${str(item.name, isBlankItem(item))}</span>
              ${icons(item.icons, { style: 'padding-left: .5em;' })}
              ${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}
          </div>`;
        }
      } else if (moRendererConfig.iconPosition === 'price') {
        line += `<div style="text-align: center;">
            <span class="name">${str(item.name, isBlankItem(item))}</span>
            ${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}
            ${icons(item.icons, { style: 'padding-right: .5em;' })}
        </div>`;
      } else {
        line += `<div style="text-align: center;">
        <span class="name">${str(item.name, isBlankItem(item))}</span>
        ${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}
    </div>`;
      }
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `<div class="description-block" style="text-align: center; line-height: 1em;">`;
      }
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="text-align: center; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<div class="description" style="text-align: center; ${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</div>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="text-align: center; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += `<div class="extras" style="text-align: center; ${moRendererConfig.inlineExtras ? `display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};` : ''}">${str(item.extras)}</div>`;
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `</div>`;
      }
      line += getModifiers(item.modifiers, moRendererConfig, 'center');
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['price-name-right'] = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = ``;
      line += hiddenBinItem(item);
      if (moRendererConfig.iconPosition === 'name') {
        if (moRendererConfig.iconAlign === 'icon-left') {
          line += `<div style="text-align: right;">
              ${icons(item.icons, { style: 'padding-right: .5em;' })}
              <span class="name">${str(item.name, isBlankItem(item))}</span>
              ${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}
          </div>`;
        } else {
          line += `<div style="text-align: right;">
              <span class="name">${str(item.name, isBlankItem(item))}</span>
              ${icons(item.icons, { style: 'padding-left: .5em;' })}
              ${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}
          </div>`;
        }
      } else if (moRendererConfig.iconPosition === 'price') {
        line += `<div style="text-align: right;">
          <span class="name">${str(item.name, isBlankItem(item))}</span>
          ${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}
          ${icons(item.icons, { style: 'padding-left: .5em;' })}
        </div>`;
      } else {
        line += `<div style="text-align: right;">
              <span class="name">${str(item.name, isBlankItem(item))}</span>
              ${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}
          </div>`;
      }
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `<div class="description-block" style="text-align: right; line-height: 1em;">`;
      }
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="text-align: right; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<div class="description" style="text-align: right; ${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</div>`;
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="text-align: right; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      line += `<div class="extras" style="text-align: right; ${moRendererConfig.inlineExtras ? `display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};` : ''}">${str(item.extras)}</div>`;
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `</div>`;
      }
      line += getModifiers(item.modifiers, moRendererConfig, 'right');
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['price-description-left'] = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = processItemNameAndIcons(item, { tag: 'div' }, moRendererConfig.iconAlign, moRendererConfig.iconPosition);
      line += hiddenBinItem(item);
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `<div class="description-block" style="line-height: 1em;">`;
      }
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += `<div>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<span class="description" style="${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</span>`
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.inlineExtras) line += `${moRendererConfig.inlineExtras ? `<div class="extras" style="display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};">${str(item.extras)}</div>` : ''}`;
      line += `${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}`;
      if (moRendererConfig.iconPosition === 'price') line += `${icons(item.icons, { style: 'padding-left: .5em;' })}`;
      line += `</div>`;
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += moRendererConfig.inlineExtras ? '' : `<div class="extras">${str(item.extras)}</div>`;
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `</div>`;
      }
      line += getModifiers(item.modifiers, moRendererConfig);
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['price-description-float-right'] = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = processItemNameAndIcons(item, { tag: 'div' }, moRendererConfig.iconAlign, moRendererConfig.iconPosition);
      line += hiddenBinItem(item);
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `<div class="description-block" style="line-height: 1em;">`;
      }
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += `<div>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<span class="description" style="${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</span>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.inlineExtras) line += `<span class="extras" style="display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};">${str(item.extras)}</span>`;
      line += `<span class="price-icons" style="padding-left: .5em; display: inline; float: right;">`
      line += `${prices(item.prices, { style: 'display: inline; float: left;', hidePrices: moRendererConfig.hidePrices })}`;
      if (moRendererConfig.iconPosition === 'price') line += `${icons(item.icons, { style: 'padding-left: .5em;' })}`;
      line += `</span>`;
      line += `</div>`;
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += moRendererConfig.inlineExtras ? '' : `<div class="extras" style="${moRendererConfig.inlineExtras ? `display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};` : ''}">${str(item.extras)}</div>`;
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') line += `</div>`;
      line += getModifiers(item.modifiers, moRendererConfig);
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['price-description-center'] = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = processItemNameAndIcons(item, { style: 'text-align: center;', tag: 'div' }, moRendererConfig.iconAlign, moRendererConfig.iconPosition);
      line += hiddenBinItem(item);
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `<div class="description-block" style="line-height: 1em;">`;
      }
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="text-align: center; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += `<div style="text-align: center;">`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<span class="description" style="${moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.description)}</span>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.inlineExtras) line += `<div class="extras" style="display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};">${str(item.extras)}</div>`;
      line += `${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}`;
      if (moRendererConfig.iconPosition === 'price') line += `${icons(item.icons, { style: 'padding-left: .5em;' })}`;
      line += `</div>`;
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="text-align: center; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += moRendererConfig.inlineExtras ? '' : `<div class="extras" style="text-align: center; ${moRendererConfig.inlineExtras ? `display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};` : ''}">${str(item.extras)}</div>`;
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') line += `</div>`;
      line += getModifiers(item.modifiers, moRendererConfig, 'center');
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['price-description-right'] = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = processItemNameAndIcons(item, { style: 'text-align: right;', tag: 'div' }, moRendererConfig.iconAlign, moRendererConfig.iconPosition);
      line += hiddenBinItem(item);
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `<div class="description-block" style="line-height: 1em;">`;
      }
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="text-align: right; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += `<div style="text-align: right;">`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<span class="description" style="${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</span>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.inlineExtras) line += `<span class="extras" style="display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};">${str(item.extras)}</span>`;
      line += `${prices(item.prices, { style: computePriceStyle($clone, 'padding-left: .5em; display: inline;', item.prices), hidePrices: moRendererConfig.hidePrices })}`;
      if (moRendererConfig.iconPosition === 'price') line += `${icons(item.icons, { style: 'padding-left: .5em;' })}`;
      line += `</div>`;
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="text-align: right; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') line += `</div>`;
      if (!moRendererConfig.inlineExtras) line += `<div class="extras" style="text-align: right; ${moRendererConfig.inlineExtras ? `display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};` : ''}">${str(item.extras)}</div>`;
      line += getModifiers(item.modifiers, moRendererConfig, 'right');
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer.stacked = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = processItemNameAndIcons(item, { style: 'text-align: center;', tag: 'div' }, moRendererConfig.iconAlign, moRendererConfig.iconPosition);
      line += hiddenBinItem(item);
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') line += `<div class="description-block" style="text-align: center; line-height: 1em;">`;
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="text-align: center; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<div class="description" style="text-align: center; ${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</div>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.inlineExtras) {
        line += `<div class="extras" style="text-align: center; padding-left: ${moRendererConfig.inlineExtrasLeftPadding}; display: inline;">${str(item.extras)}</div>`;
      }
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="text-align: center; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += `<div style="text-align: center;">${prices(item.prices, { style: computePriceStyle($clone, '', item.prices), hidePrices: moRendererConfig.hidePrices })}`;
      if (moRendererConfig.iconPosition === 'price') line += `${icons(item.icons, { style: 'padding-left: .5em;' })}`;
      line += `</div>`;
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') line += '</div>';
      if (!moRendererConfig.inlineExtras) line += `<div class="extras" style="text-align: center;">${str(item.extras)}</div>`;
      line += getModifiers(item.modifiers, moRendererConfig, 'center');
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['stacked-left'] = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = processItemNameAndIcons(item, { style: 'text-align: left;', tag: 'div' }, moRendererConfig.iconAlign, moRendererConfig.iconPosition);
      line += hiddenBinItem(item);
      if (moRendererConfig.inlineExtras) {
        line += `<div class="description-block" style="line-height: 1em;">`;
      }
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="text-align: left; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<div class="description" style="text-align: left; ${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</div>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.inlineExtras) {
        line += `<div class="extras" style="text-align: left; padding-left: ${moRendererConfig.inlineExtrasLeftPadding}; display: inline;">${str(item.extras)}</div>`;
      }
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="text-align: left; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += `<div style="text-align: left;">${prices(item.prices, { style: computePriceStyle($clone, '', item.prices), hidePrices: moRendererConfig.hidePrices })}`;
      if (moRendererConfig.iconPosition === 'price') line += `${icons(item.icons, { style: 'padding-left: .5em;' })}`;
      line += `</div>`;
      if (!moRendererConfig.inlineExtras) line += `<div class="extras" style="text-align: left;">${str(item.extras)}</div>`;
      if (moRendererConfig.inlineExtras) {
        line += `</div>`;
      }
      line += getModifiers(item.modifiers, moRendererConfig);
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer.compact = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = '';
      line += hiddenBinItem(item);
      line += '<div>';
      line += processItemNameAndIcons(item, {}, moRendererConfig.iconAlign, moRendererConfig.iconPosition);
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `${item.tag ? '\u00A0' : ''}<span class="tag" style="text-align: left; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</span>${item.tag ? '\u00A0' : ''}`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding: 0 .5em;' });
      line += `<span class="description" style="${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">\u00A0${str(item.description)}\u00A0</span>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding: 0 .5em;' });
      if (moRendererConfig.inlineExtras) {
        line += `<span class="extras" style="display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding}; padding-right: 0.5em;">${str(item.extras)}</span>`;
      }
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `${item.tag ? '\u00A0' : ''}<span class="tag" style="text-align: left; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</span>${item.tag ? '\u00A0' : ''}`;
      }
      line += prices(item.prices, { style: computePriceStyle($clone, '', item.prices), hidePrices: moRendererConfig.hidePrices });
      if (moRendererConfig.iconPosition === 'price') line += `${icons(item.icons, { style: 'padding-left: .5em;' })}`;
      line += '</div>';
      if (!moRendererConfig.inlineExtras) line += `<div><span class="extras">${str(item.extras)}</span></div>`;
      line += getModifiers(item.modifiers, moRendererConfig);
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['compact-center'] = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = '';
      line += hiddenBinItem(item);
      line += '<div style="text-align: center">';
      line += processItemNameAndIcons(item, {}, moRendererConfig.iconAlign, moRendererConfig.iconPosition);
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `${item.tag ? '\u00A0' : ''}<span class="tag" style="text-align: left; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</span>${item.tag ? '\u00A0' : ''}`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding: 0 .5em;' });
      line += `<span class="description" style="${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">\u00A0${str(item.description)}\u00A0</span>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding: 0 .5em;' });
      if (moRendererConfig.inlineExtras) {
        line += `<span class="extras" style="display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding}; padding-right: 0.5em;">${str(item.extras)}</span>`;
      }
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `${item.tag ? '\u00A0' : ''}<span class="tag" style="text-align: left; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</span>${item.tag ? '\u00A0' : ''}`;
      }
      line += prices(item.prices, { style: computePriceStyle($clone, '', item.prices), hidePrices: moRendererConfig.hidePrices });
      if (moRendererConfig.iconPosition === 'price') line += `${icons(item.icons, { style: 'padding-left: .5em;' })}`;
      line += '</div>';
      if (!moRendererConfig.inlineExtras) line += `<div style="text-align: center"><span class="extras">${str(item.extras)}</span></div>`;
      line += getModifiers(item.modifiers, moRendererConfig, 'center');
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['price-list-compact'] = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = '';
      line += hiddenBinItem(item);
      line += '<div class="clearfix" style="position: relative">';
      line += processItemNameAndIcons(item, {}, moRendererConfig.iconAlign, moRendererConfig.iconPosition);
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `${item.tag ? '\u00A0' : ''}<span class="tag" style="text-align: left; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</span>${item.tag ? '\u00A0' : ''}`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<span class="description" style="${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">\u00A0${str(item.description)}\u00A0</span>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.inlineExtras) {
        line += `<span class="extras" style="display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding}">${str(item.extras)}</span>`;
      }
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `${item.tag ? '\u00A0' : ''}<span class="tag" style="text-align: left; ${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</span>${item.tag ? '\u00A0' : ''}`;
      }
      line += prices(item.prices, {
        style: 'display: flex; position: absolute; bottom: 1px; right: 0',
        priceStyle: 'width: 3em; display: inline-block; text-align: right;',
        hidePrices: moRendererConfig.hidePrices
      });
      line += prices(item.prices, {
        style: 'display: flex; display: inline-block;',
        priceStyle: 'width: 3em; display: inline-block;',
        clone: true,
        hidePrices: moRendererConfig.hidePrices
      });
      if (moRendererConfig.iconPosition === 'price') line += `${icons(item.icons, { style: 'padding-left: .5em;' })}`;
      line += '</div>';
      line += moRendererConfig.inlineExtras ? '' : `<div><span class="extras">${str(item.extras)}</span></div>`;
      line += getModifiers(item.modifiers, moRendererConfig);
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['price-list'] = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = '';
      line += hiddenBinItem(item);
      line += `<div class="clearfix" style="display: flex; align-items: baseline">`;
      line += processItemNameAndIcons(item, {}, moRendererConfig.iconAlign, moRendererConfig.iconPosition);
      line += `${prices(item.prices, {
        style: 'padding-left: .25em; margin-left: auto; margin-top: auto; display: flex;',
        priceStyle: 'width: 3em; display: inline-block; text-align: right;',
        hidePrices: moRendererConfig.hidePrices
      })}`;
      if (moRendererConfig.iconPosition === 'price') line += `${icons(item.icons, { style: 'padding-left: .5em;' })}`;
      line += `</div>`;
      if (moRendererConfig.inlineExtras) line += `<div class="description-block" style="line-height: 1em;">`;
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="text-align: left; ${!moRendererConfig.showTags ? 'display: none;' : ''} ${moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<div class="description" style="${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</div>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="text-align: left; ${!moRendererConfig.showTags ? 'display: none;' : ''} ${moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += `<div class="extras" style="${moRendererConfig.inlineExtras ? `display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};` : ''}">${str(item.extras)}</div>`;
      if (moRendererConfig.inlineExtras) line += '</div>';
      line += getModifiers(item.modifiers, moRendererConfig);
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['after-description-price-list'] = (items, $clone, moRendererConfig) => {
    return items.filter(it => it).map((item) => {
      let line = processItemNameAndIcons(item, { tag: 'div' }, moRendererConfig.iconAlign, moRendererConfig.iconPosition);
      line += hiddenBinItem(item);
      line += '<div style="position: relative">';
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `${item.tag ? '\u00A0' : ''}<span class="tag" style="text-align: left; ${!moRendererConfig.showTags ? 'display: none;' : ''}">${str(item.tag)}</span>${item.tag ? '\u00A0' : ''}`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<span class="description">${str(item.description)}</span>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `${item.tag ? '\u00A0' : ''}<span class="tag" style="text-align: left; ${!moRendererConfig.showTags ? 'display: none;' : ''}">${str(item.tag)}</span>${item.tag ? '\u00A0' : ''}`;
      }
      line += prices(item.prices, {
        style: 'display: flex; position: absolute; bottom: 1px; right: 0',
        priceStyle: 'width: 3em; display: inline-block; text-align: right;',
        hidePrices: moRendererConfig.hidePrices
      });
      line += prices(item.prices, {
        style: 'display: flex; display: inline-block;',
        priceStyle: 'width: 3em; display: inline-block;',
        clone: true,
        hidePrices: moRendererConfig.hidePrices
      });
      if (moRendererConfig.iconPosition === 'price') line += `${icons(item.icons, { style: 'padding-left: .5em;' })}`;
      line += '</div>';
      line += `<div><span class="extras">${str(item.extras)}</span></div>`;
      line += getModifiers(item.modifiers, moRendererConfig);
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['prices-right'] = (items, $clone, moRendererConfig) => {
    const headerCount = getMaxItemCount(items);
    return items.map((item, idx) => setGridPricesStyle(idx,
      wrap(getGridPricesContent(item, idx, $clone,
        { iconAlign: moRendererConfig.iconAlign, iconPosition: moRendererConfig.iconPosition, headerCount, showTags: moRendererConfig.showTags, menuTagLayout: moRendererConfig.menuTagLayout, hidePrices: moRendererConfig.hidePrices, inlineExtras: moRendererConfig.inlineExtras, isBinLayout: false, isBinHeader: false, isInlinePriceColumnLayout: true, showModifiers: moRendererConfig.showModifiers, modifierLayout: moRendererConfig.modifierLayout }),
        item, $clone?.find(`[data-id="${item.id}"]`)), 
      moRendererConfig.showTags, moRendererConfig.hidePrices, moRendererConfig.inlineExtras, moRendererConfig.iconPosition)).join('');
  };

  renderer['prices-right-inline-top'] = (items, $clone, moRendererConfig) => {
    const headerCount = getMaxItemCount(items);
    return items.map((item, idx) => setGridPricesStyle(idx,
      wrap(getGridPricesContent(item, idx, $clone,
        { iconAlign: moRendererConfig.iconAlign, iconPosition: moRendererConfig.iconPosition, headerCount, showTags: moRendererConfig.showTags, menuTagLayout: moRendererConfig.menuTagLayout, hidePrices: moRendererConfig.hidePrices, inlineExtras: moRendererConfig.inlineExtras, isBinLayout: false, isBinHeader: false, isInlinePriceColumnLayout: true, showModifiers: moRendererConfig.showModifiers, modifierLayout: moRendererConfig.modifierLayout, extraClasses: 'inline-top' }),
        item, $clone?.find(`[data-id="${item.id}"]`)),
      moRendererConfig.showTags, moRendererConfig.hidePrices, moRendererConfig.inlineExtras, moRendererConfig.iconPosition)).join('');
  };

  renderer['prices-right-top'] = (items, $clone, moRendererConfig) => {
    const headerCount = getMaxItemCount(items);
    return items.map((item, idx) => setGridPricesStyle(idx,
      wrap(getGridPricesContent(item, idx, $clone,
        { iconAlign: moRendererConfig.iconAlign, iconPosition: moRendererConfig.iconPosition, headerCount, showTags: moRendererConfig.showTags, menuTagLayout: moRendererConfig.menuTagLayout, hidePrices: moRendererConfig.hidePrices, inlineExtras: moRendererConfig.inlineExtras, isBinLayout: false, isBinHeader: false, isInlinePriceColumnLayout: false, showModifiers: moRendererConfig.showModifiers, modifierLayout: moRendererConfig.modifierLayout, extraClasses: 'top' }),
        item, $clone?.find(`[data-id="${item.id}"]`)),
      moRendererConfig.showTags, moRendererConfig.hidePrices, moRendererConfig.inlineExtras, moRendererConfig.iconPosition)).join('');
  };

  renderer['prices-right-bottom'] = (items, $clone, moRendererConfig) => {
    const headerCount = getMaxItemCount(items);
    return items.map((item, idx) => setGridPricesStyle(idx,
      wrap(getGridPricesContent(item, idx, $clone,
        { iconAlign: moRendererConfig.iconAlign, iconPosition: moRendererConfig.iconPosition, headerCount, showTags: moRendererConfig.showTags, menuTagLayout: moRendererConfig.menuTagLayout, hidePrices: moRendererConfig.hidePrices, inlineExtras: moRendererConfig.inlineExtras, isBinLayout: false, isBinHeader: false, isInlinePriceColumnLayout: false, showModifiers: moRendererConfig.showModifiers, modifierLayout: moRendererConfig.modifierLayout, extraClasses: 'bottom' }),
        item, $clone?.find(`[data-id="${item.id}"]`)), 
      moRendererConfig.showTags, moRendererConfig.hidePrices, moRendererConfig.inlineExtras, moRendererConfig.iconPosition)).join('');
  };

  renderer['bin-with-dot-leaders'] = (items, $clone, moRendererConfig) => {
    const prevLineHeight = $clone?.find('.item div.name-price-wrapper').css('line-height') || 'inherit';
    return items.map((item) => {
      let line = ``;
      line += `<div class="bin-item-wrapper" style="display: flex;">`;
      line += `<div class="bin-entry" style="margin-right: 0.5em; ${computeBinEntryWidth($clone)}"><div style="display: none;" class="bin-header">${item.binHeader ? item.binHeader : ''}</div><div class="bin" style="width: fit-content;">${item.bin ? item.bin : ''}</div></div>`;
      line += '<div style="flex: 1;">';
      if (moRendererConfig.iconPosition === 'name') {
        if (moRendererConfig.iconAlign === 'icon-left') {
          line += `
              <div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
                ${icons(item.icons, { style: 'padding-right: .5em;' })}
                <span class="name" style="flex: 1;">${str(item.name, isBlankItem(item))}</span>
                ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0; line-height: ${prevLineHeight};`, hidePrices: moRendererConfig.hidePrices })}
              </div>`;
        } else {
          line += `<div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
              <span class="name" style="flex: 1; margin: 0 !important;">${str(item.name, isBlankItem(item))}</span>
              ${icons(item.icons, { style: 'padding-left: .5em;' })}
              ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0; line-height: ${prevLineHeight};`, hidePrices: moRendererConfig.hidePrices })}
          </div>`;
        }
      } else if (moRendererConfig.iconPosition === 'price') {
        line += `<div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
            <span class="name" style="flex: 1; margin: 0 !important;">${str(item.name, isBlankItem(item))}</span>
            ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0; line-height: ${prevLineHeight};`, hidePrices: moRendererConfig.hidePrices })}
            ${icons(item.icons, { style: 'padding-left: .5em;' })}
        </div>`;
      } else {
        line += `<div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
            <span class="name" style="flex: 1; margin: 0 !important;">${str(item.name, isBlankItem(item))}</span>
            ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0; line-height: ${prevLineHeight};`, hidePrices: moRendererConfig.hidePrices })}
        </div>`;
      }
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `<div class="description-block" style="line-height: 1em;">`;
      }
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<div class="description" style="${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</div>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += `<div class="extras" style="${moRendererConfig.inlineExtras ? `display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};` : ''}">${str(item.extras)}</div>`;
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `</div>`;
      }
      line += getModifiers(item.modifiers, moRendererConfig);
      line += '</div>';
      line += '</div>';
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['bin-header-with-dot-leaders'] = (items, $clone, moRendererConfig) => {
    const prevLineHeight = $clone?.find('.item div.name-price-wrapper').css('line-height') || 'inherit';
    return items.map((item, idx) => {
      let line = ``;
      line += `<div class="bin-item-wrapper" style="display: flex;">`;
      line += `<div class="bin-entry" style="margin-right: 0.5em; ${computeBinEntryWidth($clone)}">`;
      if (idx === 0) {
        line += `<div class="bin-header" style="width: fit-content;">${item.binHeader ? item.binHeader : ''}</div>`;
      }
      line += `<div class="bin" style="width: fit-content;">${item.bin ? item.bin : ''}</div></div>`;
      line += `<div style="flex: 1; ${computeBinHeaderMargin($clone, idx)}">`;
      if (moRendererConfig.iconPosition === 'name') {
        if (moRendererConfig.iconAlign === 'icon-left') {
          line += `
              <div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
                ${icons(item.icons, { style: 'padding-right: .5em;' })}
                <span class="name" style="flex: 1;">${str(item.name, isBlankItem(item))}</span>
                ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0; line-height: ${prevLineHeight};`, hidePrices: moRendererConfig.hidePrices })}
              </div>`;
        } else {
          line += `<div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
            <span class="name" style="flex: 1; margin: 0 !important;">${str(item.name, isBlankItem(item))}</span>
            ${icons(item.icons, { style: 'padding-left: .5em;' })}
            ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0; line-height: ${prevLineHeight};`, hidePrices: moRendererConfig.hidePrices })}
          </div>`;
        }
      } else if (moRendererConfig.iconPosition === 'price') {
        line += `<div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
          <span class="name" style="flex: 1; margin: 0 !important;">${str(item.name, isBlankItem(item))}</span>
          ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0; line-height: ${prevLineHeight};`, hidePrices: moRendererConfig.hidePrices })}
          ${icons(item.icons, { style: 'padding-left: .5em;' })}
        </div>`;
      } else {
        line += `<div class="name-price-wrapper" style="display: flex; justify-content: flex-end; align-items: flex-end;">
          <span class="name" style="flex: 1; margin: 0 !important;">${str(item.name, isBlankItem(item))}</span>
          ${prices(item.prices, { style: `padding-left: .5em; display: inline; margin: 0; line-height: ${prevLineHeight};`, hidePrices: moRendererConfig.hidePrices })}
        </div>`;
      }
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `<div class="description-block" style="line-height: 1em;">`;
      }
      if (moRendererConfig.menuTagLayout === 'above') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-left') line += icons(item.icons, { style: 'padding-right: .5em;' });
      line += `<div class="description" style="${moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</div>`;
      if (moRendererConfig.iconPosition === 'description' && moRendererConfig.iconAlign === 'icon-right') line += icons(item.icons, { style: 'padding-left: .5em;' });
      if (moRendererConfig.menuTagLayout === 'below') {
        line += `<div class="tag" style="${!moRendererConfig.showTags ? 'display: none;' : moRendererConfig.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</div>`;
      }
      line += `<div class="extras" style="${moRendererConfig.inlineExtras ? `display: inline; padding-left: ${moRendererConfig.inlineExtrasLeftPadding};` : ''}">${str(item.extras)}</div>`;
      if (moRendererConfig.inlineExtras || moRendererConfig.iconPosition === 'description') {
        line += `</div>`;
      }
      line += getModifiers(item.modifiers, moRendererConfig);
      line += '</div>';
      line += '</div>';
      return wrap(line, item, $clone?.find(`[data-id="${item.id}"]`));
    }).join('');
  };

  renderer['bin-price-column'] = (items, $clone, moRendererConfig) => {
    const headerCount = getMaxItemCount(items);
    return items.map((item, idx) => setGridPricesStyle(idx,
      wrap(getGridPricesContent(item, idx, $clone,
        { iconAlign: moRendererConfig.iconAlign, iconPosition: moRendererConfig.iconPosition, headerCount, showTags: moRendererConfig.showTags, menuTagLayout: moRendererConfig.menuTagLayout, hidePrices: moRendererConfig.hidePrices, inlineExtras: moRendererConfig.inlineExtras, isBinLayout: true, isBinHeader: false, isInlinePriceColumnLayout: false, showModifiers: moRendererConfig.showModifiers, modifierLayout: moRendererConfig.modifierLayout, extraClasses: 'top' }),
        item, $clone?.find(`[data-id="${item.id}"]`)), 
      moRendererConfig.showTags, moRendererConfig.hidePrices, moRendererConfig.inlineExtras, moRendererConfig.iconPosition)).join('');
  };

  renderer['bin-price-column-header'] = (items, $clone, moRendererConfig) => {
    const headerCount = getMaxItemCount(items);
    return items.map((item, idx) => setGridPricesStyle(idx,
      wrap(getGridPricesContent(item, idx, $clone,
        { iconAlign: moRendererConfig.iconAlign, iconPosition: moRendererConfig.iconPosition, headerCount, showTags: moRendererConfig.showTags, menuTagLayout: moRendererConfig.menuTagLayout, hidePrices: moRendererConfig.hidePrices, inlineExtras: moRendererConfig.inlineExtras, isBinLayout: true, isBinHeader: true, isInlinePriceColumnLayout: false, showModifiers: moRendererConfig.showModifiers, modifierLayout: moRendererConfig.modifierLayout, extraClasses: 'top' }),
        item, $clone?.find(`[data-id="${item.id}"]`)), 
      moRendererConfig.showTags, moRendererConfig.hidePrices, moRendererConfig.inlineExtras, moRendererConfig.iconPosition)).join('');
  };

  renderer['bin-prices-right'] = (items, $clone, moRendererConfig) => {
    const headerCount = getMaxItemCount(items);
    return items.map((item, idx) => setGridPricesStyle(idx,
      wrap(getGridPricesContent(item, idx, $clone,
        { iconAlign: moRendererConfig.iconAlign, iconPosition: moRendererConfig.iconPosition, headerCount, showTags: moRendererConfig.showTags, menuTagLayout: moRendererConfig.menuTagLayout, hidePrices: moRendererConfig.hidePrices, inlineExtras: moRendererConfig.inlineExtras, isBinLayout: true, isBinHeader: false, isInlinePriceColumnLayout: true, showModifiers: moRendererConfig.showModifiers, modifierLayout: moRendererConfig.modifierLayout }),
        item, $clone?.find(`[data-id="${item.id}"]`)), 
      moRendererConfig.showTags, moRendererConfig.hidePrices, moRendererConfig.inlineExtras, moRendererConfig.iconPosition)).join('');
  };

  renderer['bin-prices-right-header'] = (items, $clone, moRendererConfig) => {
    const headerCount = getMaxItemCount(items);
    return items.map((item, idx) => setGridPricesStyle(idx,
      wrap(getGridPricesContent(item, idx, $clone,
        { iconAlign: moRendererConfig.iconAlign, iconPosition: moRendererConfig.iconPosition, headerCount, showTags: moRendererConfig.showTags, menuTagLayout: moRendererConfig.menuTagLayout, hidePrices: moRendererConfig.hidePrices, inlineExtras: moRendererConfig.inlineExtras, isBinLayout: true, isBinHeader: true, isInlinePriceColumnLayout: true, showModifiers: moRendererConfig.showModifiers, modifierLayout: moRendererConfig.modifierLayout }),
        item, $clone?.find(`[data-id="${item.id}"]`)), 
      moRendererConfig.showTags, moRendererConfig.hidePrices, moRendererConfig.inlineExtras, moRendererConfig.iconPosition)).join('');
  };

  renderer['prices-right-with-dot-leaders'] = (items, $clone, moRendererConfig) => {
    const headerCount = getMaxItemCount(items);
    return items.map((item, idx) => setGridPricesStyle(idx,
      wrap(getGridPricesContent(item, idx, $clone,
        { iconAlign: moRendererConfig.iconAlign, iconPosition: moRendererConfig.iconPosition, headerCount, showTags: moRendererConfig.showTags, menuTagLayout: moRendererConfig.menuTagLayout, hidePrices: moRendererConfig.hidePrices, inlineExtras: moRendererConfig.inlineExtras, isBinLayout: false, isBinHeader: false, isInlinePriceColumnLayout: true, showModifiers: moRendererConfig.showModifiers, modifierLayout: moRendererConfig.modifierLayout }),
        item, $clone?.find(`[data-id="${item.id}"]`)),
      moRendererConfig.showTags, moRendererConfig.hidePrices, moRendererConfig.inlineExtras, moRendererConfig.iconPosition, true)).join('');
  };

  renderer.default = renderer['price-name-left'];

  return renderer;
})();

function setGridPricesStyle(idx, content, showTags, hidePrices, inlineExtras, iconPosition, smallColumnGap = 'false') {
  const $content = $(content).wrapAll('<div>').parent();
  const $gridPrices = $content?.find('.grid-prices');
  let top = $gridPrices.hasClass('inline-top');

  if ($gridPrices.length) {
    $gridPrices.css({
      'display': 'flex',
      'column-gap': smallColumnGap ? '5px' : '25px'
    });

    if ($gridPrices.hasClass('top') || $gridPrices.hasClass('bottom')) {
      const $desc = $gridPrices.find('.left .description');
      $desc.css({
        'display': inlineExtras || iconPosition === 'description' ? 'inline' : 'block'
      });

      if ($desc.text().trim() !== '') {
        $desc.css({
          'margin-top': '-1px'
        });
      }

      if (showTags) {
        $gridPrices.find('.left .tag').css({
          'display': inlineExtras || iconPosition === 'description' ? 'inline' : 'block',
          'margin-top': '-1px'
        });
      }

      if ($gridPrices.hasClass('top')) {
        top = true;
        $gridPrices.find('.right .price .price-entry .sp-price').css({
          'margin-top': '0',
          'align-items': 'flex-start'
        });
      }
    } else {
      const $tag = $gridPrices.find('.left .tag');
      let tagHTML = $tag.html();
      if (tagHTML && !tagHTML.startsWith('&nbsp;')) {
        tagHTML = `&nbsp;${tagHTML}`;
        $tag.html(tagHTML);
      }

      const $description = $gridPrices.find('.left .description');
      let descHTML = $description.html();
      if (!descHTML.startsWith('&nbsp;')) {
        descHTML = `&nbsp;${descHTML}`;
        $description.html(descHTML);
      }
    }

    const $left = $gridPrices.find('.left');
    if ($left.length) {
      if ($left.hasClass('no-mr')) {
        $left.css({
          'margin-right': '0'
        });

        $left.find('span.name').css({
          'margin-right': '3px'
        });
      }
    }

    const $right = $gridPrices.find('.right');
    if ($right.length) {
      $right.css({
        'margin-left': 'auto'
      });

      if ($right.hasClass('empty')) {
        $right.css({
          'display': 'none'
        });
      }

      if ($right.hasClass('one-p')) {
        $right.find('.price .price-entry').css({
          'text-align': 'right',
          'align-items': 'flex-end'
        });
      }

      const $price = $right.find('.price');
      $price.css({
        'display': 'flex',
        'justify-content': 'flex-end',
        'height': '100%'
      });

      const $priceEntry = $price.find('.price-entry');
      $priceEntry.css({
        'text-align': 'center',
        'display': hidePrices ? 'none' : 'flex',
        'flex-direction': 'column',
        'align-items': 'center'
      });

      $priceEntry.find('.sp-size').css({
        'width': 'max-content',
        'font-size': '105%'
      });

      let spPriceCssStype = {};

      if (top) {
        spPriceCssStype = {
          ...spPriceCssStype,
          'align-items': 'flex-end',
        }
      } else {
        spPriceCssStype = {
          ...spPriceCssStype,
          'margin-top': 'auto',
          'align-items': 'flex-end',
        }
      }

      $priceEntry.find('.sp-price').css(spPriceCssStype);

      if (idx === 0) {
        if ($priceEntry.find('.sp-size:empty').length !== $priceEntry.find('.sp-size').length) {
          $priceEntry.find('.sp-size:empty').html('&nbsp;');
        }
      }
    }
  }

  return $content.html();
}

function getMaxItemCount(items) {
  const length = items.length;
  if (!length) return 0;
  let max = 0;
  for (let i = 0; i < length; i++) {
    let count = countValidPrices(items[i]);
    if (count > max) {
      max = count;
    }
  }
  return max;
}

function getItemCount($clone) {
  let max = 0;

  if ($clone) {
    $clone?.find('div.item .right .price').each(function () {
      const count = $(this).find('.price-entry').length;
      if (count > max) {
        max = count;
      }
    });
  }

  return max;
}

function computeBinHeaderMargin($clone, idx) {
  const prevStyle = $clone?.find('div.item .bin-entry+div').eq(0).attr('style') || '';
  if (idx === 0) {
    if (prevStyle.includes('margin-top') && $clone.attr('data-layout').indexOf('header') > -1) {
      const marginTop = prevStyle.split(";").find(it => it.includes('margin-top')) || '';
      if (marginTop) {
        return marginTop;
      }
    } else {
      return 'margin-top: 0;';
    }
  }
}

function computeBinEntryWidth($clone) {
  const prevStyle = $clone?.find('div.item .bin-entry').eq(0).attr('style') || '';
  if (prevStyle.includes('width')) {
    const width = prevStyle.split(";").find(it => it.includes('width')) || '';
    if (width) {
      return width;
    }
  }
}

function computePriceStyle($clone, defaultStyle, prices) {
  let priceStyle = defaultStyle;
  if ($clone) {
    const isEmpty = prices.length === 1 && isEmptySizeAndPrice(prices[0]);
    if (isEmpty) priceStyle = 'height: 0px; line-height: 0px; display: none;';
  }
  return priceStyle;
}

function computeLeftStyle($clone, idx) {
  let leftStyle = '';
  if ($clone) {
    const prevLeftStyle = $clone?.find('div.item .left').eq(0).attr('style') || '';
    if (idx === 0) {
      if (prevLeftStyle.includes('margin-top')) {
        const marginTop = prevLeftStyle.split(";").find(it => it.includes('margin-top')) || '';
        if (marginTop) {
          leftStyle = `;${marginTop}`;
        }
      }
    }
    const lineHeight = prevLeftStyle.split(";").find(it => it.includes('line-height')) || '';
    if (lineHeight) {
      leftStyle += `;${lineHeight}`;
    }
    if (leftStyle) {
      leftStyle = leftStyle.substring(1);
    }
  }
  return leftStyle;
}

function computeRightStyle($clone, idx) {
  let rightStyle = '';
  if ($clone) {
    const prevRightStyle = $clone?.find('div.item .right').eq(idx).attr('style') || '';
    const splitted = prevRightStyle.split(";");
    const lineHeight = splitted.find(it => it.includes('line-height')) || '';
    const minHeight = splitted.find(it => it.includes('min-height')) || '';
    const marginTop = splitted.find(it => it.includes('margin-top')) || '';
    if (lineHeight) {
      rightStyle += `;${lineHeight}`;
    }
    if (minHeight) {
      rightStyle += `;${minHeight}`;
    }
    if (idx === 0 && marginTop) {
      rightStyle += `;${marginTop}`;
    }
    if (rightStyle) {
      rightStyle = rightStyle.substring(1);
    }
  }
  return rightStyle;
}

function getGridPricesContent(item, idx, $clone, config) {
  let itemPrices = item.prices;

  const sameColumnsCount = getItemCount($clone) === config.headerCount;
  let priceStyle = !$clone ? '' : $clone?.find('div.item .right .price-entry').eq(0).attr('style') || '';
  const leftStyle = computeLeftStyle($clone, idx);
  const rightStyle = computeRightStyle($clone, idx);

  if (!sameColumnsCount) {
    priceStyle = '';
  }

  if (config.headerCount < itemPrices.length) {
    itemPrices = itemPrices.slice(0, -1 * (itemPrices.length - config.headerCount));
  }

  while (itemPrices.length < config.headerCount) {
    itemPrices.push(getEmptyPrice());
  }

  let itemNameAndIcons = processItemNameAndIcons(item, {}, config.iconAlign, config.iconPosition);
  let tag = `<span class="tag" style="${!config.showTags ? 'display: none;' : config.inlineExtras ? 'display: inline;' : ''}">${str(item.tag)}</span>`;
  let description = `<span class="description" style="${config.inlineExtras || config.iconPosition === 'description' ? 'display: inline;' : ''}">${str(item.description)}</span>`;
  let priceList = prices(itemPrices, {
    wrapSizeSeparately: true,
    hideSize: !!idx,
    priceStyle,
    hidePrices: config.hidePrices,
  });
  const extrasEmpty = str(item.extras) === '';
  let extras = config.inlineExtras ? `<span class="extras" style="display: inline; padding-left: ${inlineExtrasLeftPadding};">${str(item.extras)}</span>`
    : `<div style="${extrasEmpty ? 'display: none;' : ''}"><span class="extras" style="display: inline;">${str(item.extras)}</span></div>`;

  let left = config.isBinLayout ?
    `<div class="left ${config.headerCount === 0 ? 'no-mr' : ''}" style="${leftStyle}; display: flex;">
    <div class="bin-entry" style="margin-right: 0.5em; ${computeBinEntryWidth($clone)}">
      ${config.isBinHeader && idx === 0 ? `<div class="bin-header" style="width: fit-content;">${item.binHeader ? item.binHeader : ''}</div>` : `<div style="display: none;" class="bin-header">${item.binHeader ? item.binHeader : ''}</div>`}
      <div class="bin" style="width: fit-content;">${item.bin ? item.bin : ''}</div>
    </div>
    <div style="flex: 1; width: fit-content; ${computeBinHeaderMargin($clone, idx)}">
      ${itemNameAndIcons}
      ${(config.inlineExtras || config.iconPosition === 'description') && !config.isInlinePriceColumnLayout ? `<div class="description-block" style="line-height: 1em;">` : ''}
      ${config.menuTagLayout === 'above' ? tag : ''}
      ${config.iconPosition === 'description' && config.iconAlign === 'icon-left' ? icons(item.icons, { style: 'padding-right: .5em;' }) : ''}
      ${description}
      ${config.iconPosition === 'description' && config.iconAlign === 'icon-right' ? icons(item.icons, { style: 'padding-left: .5em;' }) : ''}
      ${config.menuTagLayout === 'below' ? tag : ''}
      ${!config.inlineExtras && config.iconPosition === 'description' && !config.isInlinePriceColumnLayout ? '</div>' : ''}
      ${extras}
      ${config.inlineExtras && !config.isInlinePriceColumnLayout ? '</div>' : ''}
    </div>
  </div>`
    :
    `<div class="left ${config.headerCount === 0 ? 'no-mr' : ''}" style="${leftStyle}">
    ${hiddenBinItem(item)}
    ${itemNameAndIcons}
    ${(config.inlineExtras || config.iconPosition === 'description') && !config.isInlinePriceColumnLayout ? `<div class="description-block" style="line-height: 1em;">` : ''}
    ${(config.inlineExtras || config.iconPosition === 'description') && config.isInlinePriceColumnLayout ? `<span class="description-block" style="line-height: 1em;">` : ''}
    ${config.menuTagLayout === 'above' ? tag : ''}
    ${config.iconPosition === 'description' && config.iconAlign === 'icon-left' ? icons(item.icons, { style: 'padding-right: .5em;' }) : ''}
    ${description}
    ${config.iconPosition === 'description' && config.iconAlign === 'icon-right' ? icons(item.icons, { style: 'padding-left: .5em;' }) : ''}
    ${config.menuTagLayout === 'below' ? tag : ''}
    ${!config.inlineExtras && config.iconPosition === 'description' && !config.isInlinePriceColumnLayout ? '</div>' : ''}
    ${!config.inlineExtras && config.iconPosition === 'description' && config.isInlinePriceColumnLayout ? '</span>' : ''}
    ${extras}
    ${config.inlineExtras && !config.isInlinePriceColumnLayout ? '</div>' : ''}
    ${config.inlineExtras && config.isInlinePriceColumnLayout ? '</span>' : ''}
  </div>`;
  let right = `<div class="right ${config.headerCount === 0 ? 'empty' : ''} ${config.headerCount === 1 ? 'one-p' : ''}" style="${rightStyle}">${priceList}</div>`;
  let modifiers = getModifiers(item.modifiers, config);
  return `<div class="grid-prices ${config.extraClasses}">${left}${right}</div>${modifiers}`;
}

export function getFromJson(priceData) {
  let data;
  try {
    if (typeof priceData === 'object' && priceData.hasOwnProperty('size') && priceData.hasOwnProperty('price') && priceData.hasOwnProperty('displayPrice')) {
      return priceData;
    }

    data = JSON.parse(priceData || "{size: '', price: '', displayPrice: ''}");
    if (typeof data !== 'object') {
      let price = data;
      data = { price: price, displayPrice: price, size: "" };
    }
  } catch (ex) {
    data = { price: priceData.price, displayPrice: priceData.price, size: "" };
  }
  return data;
}

export const str = (value, useNbspOnEmpty) => {
  if (!value) return useNbspOnEmpty ? '&nbsp;' : '';

  value = value.replace(/\r\n/g, '<br/>');
  value = value.replace(/\n/g, '<br/>');

  if (!value) {
    value = useNbspOnEmpty ? '&nbsp;' : '';
  }

  return value;
}

function isBlankItem(item) {
  return !item.name && !item.description && !item.extras;
}

export function getSizeAndPrice(priceData, wrapSizeSeparately, hideSize) {
  return formatSizeAndPrice(getFromJson(priceData), wrapSizeSeparately, hideSize);
}
export function formatSizeAndPrice(obj, wrapSizeSeparately, hideSize, onlySize, onlyPrice) {
  let { displayPrice, size } = obj;
  size = size?.replace(/&dqt/g, '"') || '';
  displayPrice = displayPrice?.replace(/&dqt/g, '"') || '';

  if (wrapSizeSeparately) {
    if (onlySize) {
      return `<span class="sp-size">${size}</span>`;
    } else if (onlyPrice || hideSize) {
      return `<span class="sp-price">${displayPrice}</span>`;
    } else {
      return `<span class="sp-size" ${hideSize ? 'style="display: none;"' : ''}>${size}</span><span class="sp-price">${displayPrice}</span>`;
    }
  } else {
    let str = size;
    if (str && str.trim().length) {
      str += " ";
    }
    str += displayPrice;
    return str;
  }
}

export function isEmptySizeAndPrice(priceData) {
  const { price, size } = getFromJson(priceData);
  return !`${price}${size}`.trim().length;
}

export function countValidPrices(item) {
  const prices = item.prices.toReversed();
  let trailingEmptiesPopped = false;
  while (!trailingEmptiesPopped) {
    if (prices[0] && isEmptySizeAndPrice(prices[0])) {
      prices.shift();
    } else {
      trailingEmptiesPopped = true;
    }
  }
  return prices.length;
}

export default Renderer;
